import Hash from "../utils/Hash";
import Model from "./Model";

export default class Link extends Model {

	constructor(props = {}) {

		super({});

		this.setDefaultValues({
			id: null,
			guid: Hash.guid(),
			type: 'default',
			hash: null,
			meta: {}
		}, props);
	}
}
